"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsUpdateKeywords = exports.googleAdsUpdateKeywordsResultSchema = exports.googleAdsUpdateKeywordsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsUpdateKeywordsInputSchema = zod_1.z
    .object({
    criterionResourceName: zod_1.z
        .string()
        .describe('The resource name of the keyword to update (e.g., customers/123/adGroupCriteria/456~789)'),
    status: zod_1.z
        .enum(['ENABLED', 'PAUSED', 'REMOVED'])
        .nullish()
        .describe('New status for the keyword'),
    cpcBidMicros: zod_1.z
        .number()
        .positive()
        .nullish()
        .describe('New CPC bid in micros (e.g., 1000000 = $1.00)'),
})
    .describe('Update an existing Google Ads keyword.');
exports.googleAdsUpdateKeywordsArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsUpdateKeywordsInputSchema);
var googleAdsUpdateKeywordsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    resourceName: zod_1.z.string().nullish(),
    message: zod_1.z.string().nullish(),
});
exports.googleAdsUpdateKeywordsResultSchema = googleAdsUpdateKeywordsResponseSchema;
exports.googleAdsUpdateKeywords = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsUpdateKeywords',
    displayName: 'Google Ads Update Keywords',
    displayDescription: 'Update an existing Google Ads keyword. Can change status or CPC bid.',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsUpdateKeywordsArgsSchema,
}, googleAdsUpdateKeywordsResponseSchema);
